module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_8019.b29b2726.png";